import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { concat, Observable, of, Subject } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { LocationService } from '@app/core/locations/services/location.service';
import { RfqService } from '@app/core/quotes';
import { StaffService } from '@app/core/staff';

@Component({
  selector: 'cnc-update-rfq-locations',
  templateUrl: './update-rfq-locations.component.html',
  styleUrls: ['./update-rfq-locations.component.scss'],
})
export class UpdateRfqLocationsComponent implements OnInit {
  formData :UntypedFormGroup;
  pageTitle :string = 'Product / SKU location transfer';
  submitted :boolean = false;
  loading :boolean = false;

  locations :any[] = [];
  warehouses :any[] = [];
  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();

  @Input() rfq :any;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private toastr :ToastrService,
    private rfqSvc :RfqService,
    public locationSvc :LocationService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      transfer_type: [null, [Validators.required]],
      locations: [null, [Validators.required]],
      rfq: [null, [Validators.required]],
      previous_locations: this.fb.array([]),
    });

    // get locations
    this.locationSvc.getAll({ all: 1 }).subscribe((resp) => {
      this.warehouses = resp.filter((row) => row.parent_id == 0);
      this.warehouses.forEach((row) => {
        row.locations = resp.filter((loc) => loc.parent_id == row.id);
      });
      // this.cd.detectChanges();
    });
    // this.locationSvc.getAll({ all: 1 }).subscribe((resp) => {
    //     this.locations = resp;
    // })

    if (this.rfq && this.rfq.id) {
      this.formData.get('rfq').patchValue(this.rfq);
      this.setRfq();
    }

    this.loadRfqs();
  }

  onSubmit() {
    if (this.formData.invalid) {
      Swal.fire('Error', 'Please complete the form to save transfers.', 'error');

      return;
    }
    const data = this.formData.value;

    const postData :any = {};
    postData.transfer_type = data.transfer_type;
    postData.rfq_id = data.rfq.id;
    postData.sku = data.rfq.internal_sku;
    postData.locations = [];
    data.locations.forEach((loc :any) => {
      postData.locations.push({
        id: loc.id,
        name: loc.location_name,
        parent_id: loc.parent_id,
      });
    });
    if (data.transfer_type == 2 && data.previous_locations) {
      postData.previous_locations = [];
      data.previous_locations.forEach((val, idx) => {
        if (val) {
          const loc = data.rfq.locations[idx];
          postData.previous_locations.push({
            id: loc.location_id,
            name: loc.location_name,
            parent_id: loc.parent_id,
          });
        }
      });
    }

    this.loading = true;
    this.rfqSvc.transferLocations(data.rfq.id, postData).subscribe((resp) => {
      this.loading = false;
      this.toastr.success('Updated successfully.', 'Success');
      this.activeModal.close(resp.record);
    });
  }

  setRfq() {
    const previousLocations :UntypedFormArray = this.formData.get(
      'previous_locations',
    ) as UntypedFormArray;
    previousLocations.reset();
    this.formData.value.rfq.locations.forEach((loc) => {
      previousLocations.push(new UntypedFormControl(false));
    });
  }

  trackByFn(item :any) {
    return item.id;
  }

  private loadRfqs() {
    this.rfq$ = concat(
      of([]), // default items
      this.rfqInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.rfqLoading = true)),
        switchMap((term) =>
          this.rfqSvc.getAsync({ sku: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.rfqLoading = false)),
            map((resp) => resp.data),
          ),
        ),
      ),
    );
  }
}
